<template>
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel" style="font-size: 14px;">Eliminar Registro</h4>
                <button ref="closeDeleteVacationsModal" class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="form theme-form" v-if="vacation">
                    ¿Estás seguro que deseas eliminar el día <b>{{ $formatDate(vacation.date+"") }}</b> de las vacaciones que ha tomado el empleado <b>{{ employee.name }}</b>?
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-danger btn-sm" type="button" style="float: right;" title="btn btn-success btn-sm" @click="deleteVacations">Eliminar</button>
            </div>
        </div>
    </div>
</template>
<script>
import ws from '@/services/employees'

import '@vuepic/vue-datepicker/dist/main.css'

export default {
    name: 'employee_absence_modal',
    mixins: [],
    props: {
        employees: Array,
    },
    components: {
        
    },
    data(){
        return{
            showModal: true,
            employee: null,
            vacation: null,
            period: null
        }
    },
    methods: {
        loadEmployee(employee, vacation, period){
            this.vacation = vacation;
            this.employee = employee;
            this.period = period;
        },
        async deleteVacations() {
            let response = await ws.deleteVacations(this.employee.id, this.vacation.id, this.period);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.closeModal();

                this.$emit("refresh", response.data );
            }
            else{
                this.$toast.error(response.message);
            }
        },
        closeModal(){
            this.$refs.closeDeleteVacationsModal.click();
        }
    }
}
</script>